import { fetchAmplifyContext, signIn } from './SignIn.commands';
import {
    getEmail,
    getError,
    isFetchingContext,
    isLoading,
    isSsoEnabled,
    shouldRemember,
} from '../../../state/Auth.selectors';

export const mapStateToProps = state => {
    return {
        error: getError(state),
        isLoading: isLoading(state) || isFetchingContext(state),
        email: getEmail(state),
        rememberMe: shouldRemember(state),
        ssoEnabled: isSsoEnabled(state),
    };
};

export const mapDispatchToProps = dispatch => {
    return {
        onSignIn: params => {
            const { useCognito } = params;
            if (!useCognito) {
                return dispatch(fetchAmplifyContext(params));
            }
            return dispatch(signIn(params));
        },
    };
};
